import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#111111",
      medium: "#00337C",
      light: "#1C82AD",
    },
    secondary: {
      main: "#f2f2f2",
    },
  },
});
